import { useDispatch, useSelector } from "react-redux";
import { getTransactionsDetailsAction } from "../../redux/actions/currenciesActions";
import {
    permanentTransactionHeadersList,
    probTransactionHeadersList,
    tempSortOptions,
    tempTransactionHeadersList
} from "../../staticData/transactions";
import TransactionsDetails from "./TransactionsDetails";

const OrdersStatus = ({}) => {
    const { currenciesList, isDarkMode, currentCurrencyId, transSpinnerStatus } = useSelector(
        (state) => state.persistedReducer,
        (oldValue, newValue) => {
            const {
                totalStatus: { activePosition: oldActivePosition }
            } = oldValue?.currenciesList[oldValue?.currentCurrencyId];
            const {
                totalStatus: { activePosition: newActivePosition }
            } = newValue?.currenciesList[newValue?.currentCurrencyId];
            if (
                oldValue.transSpinnerStatus !== newValue.transSpinnerStatus ||
                oldValue.isDarkMode !== newValue.isDarkMode ||
                newValue?.currentCurrencyId !== oldValue?.currentCurrencyId ||
                oldActivePosition !== newActivePosition
            ) {
                return false;
            }
            return true;
        }
    );
    const {
        tempTransactionsData: { data: tempTransData, rowsLength: tempRowsLength },
        permanentTransactionsData: { data: permTransData, rowsLength: permRowsLength },
        probabilityTransactionsData: { data: probTransData, rowsLength: probRowsLength },
        totalStatus,
        operations: { isModelOn, isRenkoCreationOn },
        decimalNumber
    } = currenciesList[currentCurrencyId];
    const dispatch = useDispatch();
    const transactionsDataList = [
        {
            headersList: tempTransactionHeadersList,
            sortOptions: tempSortOptions,
            transactionParams: { categ: "TEMP", obj: "tempTransactionsData" },
            transactionsData: tempTransData,
            rowsLength: tempRowsLength,
            ComponentName: "Temp Transaction Details"
        },
        {
            headersList: permanentTransactionHeadersList,
            sortOptions: tempSortOptions,
            transactionParams: { categ: "PERM", obj: "permanentTransactionsData" },
            transactionsData: permTransData,
            rowsLength: permRowsLength,
            ComponentName: "Permanent Transaction Details"
        },
        {
            headersList: probTransactionHeadersList,
            sortOptions: tempSortOptions,
            transactionParams: { categ: "PROB", obj: "probabilityTransactionsData" },
            transactionsData: probTransData,
            rowsLength: probRowsLength,
            ComponentName: "Probability Transaction Details"
        }
    ];
    return (
        <fieldset className=" flex flex-col w-full items-center primaryBorder rounded-sm mt-2 pb-2">
            <legend className="text-sm">Total Status</legend>
            <ul className="w-full px-3 bg-transparent flex flex-col  ">
                <li
                    className={`flex  p-2 rounded-lg my-1 ${
                        isDarkMode ? "bg-secondaryDark" : "bg-secondaryLight"
                    }`}>
                    <div className="flex-1 text-vsm">Active Position</div>
                    <div className="flex-1 text-vsm flex justify-end">
                        {(isModelOn && isRenkoCreationOn && totalStatus?.activePosition) ||
                            "NO POSITION"}
                    </div>
                </li>
                <li
                    className={`flex  p-2 rounded-lg my-1 ${
                        isDarkMode ? "bg-secondaryDark" : "bg-secondaryLight"
                    }`}>
                    <div className="flex-1 text-vsm">Last Position Profit</div>
                    <div className="flex-1 text-vsm flex justify-end">
                        {totalStatus?.isPositionOpen && isModelOn && isRenkoCreationOn
                            ? "calculating..."
                            : Number(totalStatus?.lastPositionProfit || 0).toFixed(
                                  decimalNumber || 5
                              )}
                    </div>
                </li>
                <li
                    className={`flex  p-2 rounded-lg my-1 ${
                        isDarkMode ? "bg-secondaryDark" : "bg-secondaryLight"
                    }`}>
                    <div className="flex-1 text-vsm">Entry Date: </div>

                    <div className="flex-1 text-vsm  flex justify-end">
                        {isModelOn && isRenkoCreationOn
                            ? totalStatus?.isPositionOpen
                                ? totalStatus?.indexZero
                                : totalStatus?.indexOne
                            : ""}
                    </div>
                </li>
                <li
                    className={`flex  p-2 rounded-lg my-1 ${
                        isDarkMode ? "bg-secondaryDark" : "bg-secondaryLight"
                    }`}>
                    <div className="flex-1 text-vsm">Exit Date: </div>
                    <div className="flex-1 text-vsm  flex justify-end">
                        {isModelOn && isRenkoCreationOn
                            ? totalStatus?.isPositionOpen
                                ? null
                                : totalStatus?.indexZero
                            : ""}{" "}
                    </div>
                </li>

                <li
                    className={`flex  p-2 rounded-lg my-1 ${
                        isDarkMode ? "bg-secondaryDark" : "bg-secondaryLight"
                    }`}>
                    <div className="flex-1 text-vsm">Accumalative Profit</div>
                    <div className="flex-1 text-vsm flex justify-end">
                        {totalStatus?.isPositionOpen && isModelOn && isRenkoCreationOn
                            ? "calculating..."
                            : Number(totalStatus?.accumulativeProfit).toFixed(4)}
                    </div>
                </li>
            </ul>
            {transactionsDataList.map((tranacion, index) => {
                const {
                    sortOptions,
                    transactionParams,
                    transactionsData,
                    rowsLength,
                    ComponentName,
                    headersList
                } = tranacion;
                return (
                    <TransactionsDetails
                        key={index}
                        headersList={headersList}
                        sortOptions={sortOptions}
                        receiveDataFunction={(page, sort) =>
                            dispatch(
                                getTransactionsDetailsAction({
                                    page,
                                    sort,
                                    type: transactionParams
                                })
                            )
                        }
                        transactionsData={transactionsData}
                        rowsLength={rowsLength}
                        currentCurrencyId={currentCurrencyId}
                        transSpinnerStatus={transSpinnerStatus}
                        ComponentName={ComponentName}
                        isDarkMode={isDarkMode}
                        transactionType={transactionParams.categ}
                    />
                );
            })}
        </fieldset>
    );
};

export default OrdersStatus;
